export default "__VITE_ASSET__CrIS9zXh__"